module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="content-headerFixed">\r\n    <h1 class="pull-left">'+
((__t=( table ))==null?'':_.escape(__t))+
'</h1>\r\n    ';
 if(rolee  < 2){ 
__p+='\r\n\r\n        '+
((__t=(lang.NEW))==null?'':_.escape(__t))+
'\r\n            </span>\r\n            ';
 } 
__p+='\r\n    <div class="clear"></div>\r\n</section>\r\n\r\n<section class="content" >\r\n    <div class="row content-marginFixed">\r\n        <div class="col-md-12">\r\n            <form id="searchForm">\r\n                <div class="box">\r\n                    <div class="box-header with-border">\r\n                        <h3 class="box-title"><i class="ion ion-search"></i>'+
((__t=(lang.SEARCH))==null?'':_.escape(__t))+
'</h3>\r\n                        <div class="box-tools pull-right">\r\n                            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>\r\n                            </button>\r\n                        </div>\r\n                    </div>\r\n                    <div class="box-body">\r\n                        <div id="lines">                \r\n                        </div>\r\n                    </div>\r\n                    <div class="box-footer">\r\n                        <button type="submit" class="btn btn-info btn-small btn-flat" id="search"><span class="ion ion-funnel"></span> '+
((__t=(lang.FILTRAR))==null?'':_.escape(__t))+
'</button>\r\n                        <button type="button" class="btn btn-danger btn-small btn-flat" id="removeFilter"><span class="ion ion-close"></span></button>\r\n                    </div>\r\n                </div>\r\n            </form>  \r\n        </div>\r\n        <div class="col-md-12 gtable-responsive form-group">\r\n            <table id="mainData"></table>            \r\n        </div>\r\n        <div class="col-md-12">\r\n            <div id="paginationHolder"></div>\r\n        </div>\r\n    </div>\r\n</section>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/masters/mastersView.ejs
// module id = 429
// module chunks = 0